import {
  FETCH_JOB_PORTAL_JOB_LIST,
  FETCH_JOB_PORTAL_JOB_LIST_SUCCESS,
  FETCH_JOB_PORTAL_JOB_LIST_FAILURE,
  RESET_JOB_PORTAL_JOB_LIST,
  FETCH_JOB_PORTAL_JOB,
  FETCH_JOB_PORTAL_JOB_SUCCESS,
  FETCH_JOB_PORTAL_JOB_FAILURE,
  RESET_FETCH_JOB_PORTAL_JOB_ERROR,
  FETCH_JOB_PORTAL_WORK_LOCATIONS,
  FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS,
  FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE,
  PARSE_JOB_PORTAL_RESUME,
  PARSE_JOB_PORTAL_RESUME_SUCCESS,
  PARSE_JOB_PORTAL_RESUME_FAILURE,
  RESET_JOB_PORTAL_RESUME,
  POST_JOB_PORTAL_JOB_APPLICATION,
  POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS,
  POST_JOB_PORTAL_JOB_APPLICATION_FAILURE,
  SELECT_JOB_PORTAL_JOB,
  RESET_JOB_PORTAL_SELECTED_JOB,
  SET_SEARCH_VALUES,
  SET_FILTER_VALUES,
  SET_WORKMODE_FILTER,
  SET_LOCATION_FILTER,
  SET_JOBTYPE_FILTER,
  SET_PAGE_NUMBER,
  SET_DIV_SCROLL_Y_POSITION,
  SET_WINDOW_SCROLL_Y_POSITION,
  SET_SUCCESS_STATE,
  FETCH_JOB_PORTAL_JOB_NO_FILTER,
  FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS,
  FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE,
} from "./actionTypes";

const initialState = {
  job: {},
  jobData: {},
  jobList: [],
  resumeData: {},
  workLocations: [],
  selectedJob: null,
  search: {
    keyword: "",
    country: "",
  },
  filter: {
    workModes: [],
    locations: [],
    jobTypes: [],
  },
  pageNumber: 0,
  divScrollYPosition: 0,
  windowScrollYPosition: 0,
  loading: false,
  success: false,
  error: false,
  fetchJobError: false,
  errorMsg: "",
  jobNofilter: {},
};

const JobPortalJobReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_JOB_PORTAL_JOB_LIST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_JOB_PORTAL_JOB_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        jobData: action.payload,
        jobList: [...state.jobList, ...action.payload.content],
      };
    case FETCH_JOB_PORTAL_JOB_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case RESET_JOB_PORTAL_JOB_LIST:
      return {
        ...state,
        jobData: {},
        jobList: [],
        loading: false,
        error: false,
        errorMsg: "",
      };
    case FETCH_JOB_PORTAL_JOB:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_JOB_PORTAL_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        job: action.payload,
      };
    case FETCH_JOB_PORTAL_JOB_FAILURE:
      return {
        ...state,
        loading: false,
        fetchJobError: true,
        errorMsg: action.payload,
      };
    case FETCH_JOB_PORTAL_WORK_LOCATIONS:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_JOB_PORTAL_WORK_LOCATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        workLocations: action.payload,
      };
    case FETCH_JOB_PORTAL_WORK_LOCATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload
      };
    case RESET_FETCH_JOB_PORTAL_JOB_ERROR:
      return {
        ...state,
        fetchJobError: false,
        errorMsg: "",
      };
    case PARSE_JOB_PORTAL_RESUME:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case PARSE_JOB_PORTAL_RESUME_SUCCESS:
      return {
        ...state,
        resumeData: action.payload,
        loading: false,
      };
    case PARSE_JOB_PORTAL_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case RESET_JOB_PORTAL_RESUME:
      return {
        ...state,
        resumeData: {},
        loading: false,
        error: false,
        errorMsg: "",
      };
    case POST_JOB_PORTAL_JOB_APPLICATION:
      return {
        ...state,
        loading: true,
        success: false,
        error: false,
      };
    case POST_JOB_PORTAL_JOB_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case POST_JOB_PORTAL_JOB_APPLICATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload,
      };
    case SELECT_JOB_PORTAL_JOB:
      return {
        ...state,
        selectedJob: action.payload,
      };
    case RESET_JOB_PORTAL_SELECTED_JOB:
      return {
        ...state,
        selectedJob: {},
      };
    case SET_SEARCH_VALUES:
      return {
        ...state,
        search: {
          ...state.search,
          [action.payload.search]: action.payload.value,
        },
      };
    case SET_FILTER_VALUES:
      return {
        ...state,
        filter: action.payload,
      };
    case SET_WORKMODE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          workModes: action.payload,
        },
      };
    case SET_LOCATION_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          locations: action.payload,
        },
      };
    case SET_JOBTYPE_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          jobTypes: action.payload,
        },
      };
    case SET_PAGE_NUMBER:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case SET_DIV_SCROLL_Y_POSITION:
      return {
        ...state,
        divScrollYPosition: action.payload,
      };
    case SET_WINDOW_SCROLL_Y_POSITION:
      return {
        ...state,
        windowScrollYPosition: action.payload,
      };
    case SET_SUCCESS_STATE:
      return {
        ...state,
        success: action.payload,
      };
    case FETCH_JOB_PORTAL_JOB_NO_FILTER:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case FETCH_JOB_PORTAL_JOB_NO_FILTER_SUCCESS:
      return {
        ...state,
        loading: false,
        jobNofilter: action.payload,
      };
    case FETCH_JOB_PORTAL_JOB_NO_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        errorMsg: action.payload
      };
    default:
      return state;
  }
};

export default JobPortalJobReducer;
